import React, { useEffect, useState } from "react";
import { DashboardOutlined } from "@ant-design/icons";
import marie from "assets/images/HR.png";
import { getAdminData } from "Services/AdminServices/HiringService";

function EmployeeNameHeader() {
  const [recruiter, setRecruiter] = useState("");
  const userId = localStorage.getItem("userId");
  const roles = (localStorage.getItem("role") || "Administrator").trim() || "Administrator";

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return;
      const response = await getAdminData(userId);
      if (response) {
        const fullName =
          response.firstName && response.lastName
            ? `${response.firstName} ${response.lastName}`
            : response.userName;
        setRecruiter(fullName);
      }
    };
    fetchUserData();
  }, [userId]);

  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "linear-gradient(120deg, #14521D 0%, #2E7D32 55%, #4CAF50 100%)",
        borderRadius: "18px",
        padding: "22px 26px",
        boxShadow: "0 10px 26px rgba(46,125,50,0.26)",
        color: "#fff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <img
          src={marie}
          alt="admin"
          style={{
            height: 58,
            width: 58,
            borderRadius: "50%",
            border: "2px solid rgba(255,255,255,0.65)",
            objectFit: "cover",
            background: "#fff",
          }}
        />
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 600, lineHeight: 1.2 }}>
            {greeting}, {recruiter || "Admin"}
          </div>
          <div style={{ fontSize: "0.9rem", opacity: 0.9, marginTop: 3 }}>
            {roles} · {today}
          </div>
        </div>
      </div>
      <div
        style={{
          width: 54,
          height: 54,
          borderRadius: 14,
          background: "rgba(255,255,255,0.16)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 26,
        }}
      >
        <DashboardOutlined />
      </div>
    </div>
  );
}

export default EmployeeNameHeader;
